import React from 'react';
import EditModifierGroupsState from './editModifierGroupsState/EditModifierGroupsState';
import EditModifierGroupsControlPanel from './components/EditModifierGroupsControlPanel/EditModifierGroupsControlPanel';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';
// import style from './index.module.scss';

const EditModifierGroupsPage: React.FC = () => {
	return (
		<EditModifierGroupsState>
			<EditModifierGroupsControlPanel />
			<Forms />
			<ModalWindows />
		</EditModifierGroupsState>
	);
};

export default EditModifierGroupsPage;
